// Spider one suit: the colour the player picked in the Games window (player report #uh0t4g74gj, owner 2026-10-28: a
// list like Mahjong's shapes, Random / Black / Red, saved the moment it is picked), or none: a deal's suit then comes
// from its pattern (engine/rules/spider.ts suitsFromPattern). With one suit the colour changes nothing in the game.
// Kept in the browser (a won game reloads the page).
import type { Suit } from '../engine/types';

/** The colours in the list: null random, else the suit dealt (black spades, red hearts). */
export const SPIDER_COLOURS = [null, 's', 'h'] as const;
export type SpiderColour = (typeof SPIDER_COLOURS)[number];

const KEY = 'solitaire_storage:spider-colour';

export function pickedSpiderColour(): SpiderColour {
  try {
    const v = localStorage.getItem(KEY);
    return v === 's' || v === 'h' ? v : null;
  } catch {
    return null;
  }
}

export function pickSpiderColour(colour: SpiderColour): void {
  try {
    if (colour === null) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, colour);
  } catch {
    // no storage (a private window): the pick lasts until the page reloads
  }
}

/** The suits of a new one-suit deal, or undefined for the pattern's own. */
export const spiderSuits = (colour: SpiderColour): Suit[] | undefined => (colour ? [colour, colour, colour, colour] : undefined);
